import React, {createContext, useState, useEffect, useContext} from 'react';
import translations from '../utils/translations.json';
import {getCountryApiCode, getCountryCode, getLanguageFromCountry} from "../utils/country";


export const LanguageContext = createContext();

export const useLang = () => {
  return useContext(LanguageContext);
}

export const LanguageProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const [language, setLanguage] = useState('en');
  const [betTranslationErrors, setBetTranslationErrors] = useState([])

  useEffect(() => {
    const setDefaultByCountry = async () => {
      let lang = localStorage.getItem('latg-language');

      if(!lang){
        const countryCode = getCountryCode();
        lang = getLanguageFromCountry(countryCode);
      }

      if(!lang){
        const countryCode = await getCountryApiCode('b15833735ae279');
        lang = getLanguageFromCountry(countryCode);
      }

      if(!lang){
        lang = 'en';
      }

      setInnerLanguage(lang);
    }

    if(!loaded){
      setLoaded(true);
      setDefaultByCountry();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setInnerLanguage = (newLang) => {
    localStorage.setItem('latg-language', newLang);
    setLanguage(newLang);
  }

  const t = (path) => {
    const keys = path.split('.');
    let current = translations[language];
    for (const key of keys) {
      if (current[key] === undefined) {
        return path;
      }
      current = current[key];
    }
    return current;
  };

  const getBetTranslation = (originalStr) => {
    if(translations[language].gameMarket[originalStr]){
      return translations[language].gameMarket[originalStr];
    }
    if(!betTranslationErrors.includes(originalStr)){
      setBetTranslationErrors(prev => {
        return [
            ...prev,
            originalStr
        ]
      });
    }

    return originalStr;
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage:setInnerLanguage, t, getBetTranslation, betTranslationErrors }}>
      {children}
    </LanguageContext.Provider>
  );
};
